import { Checkbox, CheckboxProps } from 'antd'

import { CheckboxGroupCoreProps } from './interface'

export const CheckboxGroupCore = ({
  options,
  value,
  onChange,
  className
}: CheckboxGroupCoreProps) => {
  const handleCheckboxChange: CheckboxProps['onChange'] = e => {
    const { value: checkValue, checked } = e.target
    onChange?.(
      checked
        ? [...(value ?? []), checkValue]
        : value?.filter(item => item !== checkValue)
    )
  }

  return options.map((item, index) => (
    <Checkbox
      key={index}
      checked={value?.includes(item.value)}
      className={className}
      value={item.value}
      onChange={handleCheckboxChange}
    >
      {item.label}
    </Checkbox>
  ))
}
